import { Flex, Skeleton, Row, Col } from "antd";

import { ComponentContainer, LayoutGrid } from "../../LayoutContainers";
import { colors } from "../../../utils/variables";

export const SkeletonMarquee = () => {
    return (
        <Flex className="marquee" justify="center" align="middle">
            <Skeleton.Input className="home__marquee darkMode" active={true} />
            <Skeleton.Input className="home__marquee darkMode" active={true} />
            <Skeleton.Input className="home__marquee darkMode" active={true} />
            <Skeleton.Input className="home__marquee darkMode" active={true} />
            <Skeleton.Input className="home__marquee darkMode" active={true} />
            <Skeleton.Input className="home__marquee darkMode" active={true} />
            <Skeleton.Input className="home__marquee darkMode" active={true} />
            <Skeleton.Input className="home__marquee darkMode" active={true} />
            <Skeleton.Input className="home__marquee darkMode" active={true} />
        </Flex>
    );
};

export const SkeletonRankings = () => {
    return (
        <ComponentContainer bgColor={colors.blackish_10}>
            <LayoutGrid spacingTop="8" spacingBottom="4" cols={1}>
                <Skeleton active={true} />

                <Flex className="mb-2 mt-2" gap="1.5rem">
                    <Skeleton.Input active={true} />
                    <Skeleton.Input active={true} />
                    <Skeleton.Input active={true} />
                    <Skeleton.Input active={true} />
                    <Skeleton.Input active={true} />
                </Flex>

                <Row gutter={16}>
                    <Col span={8}>
                        <Flex vertical gap="1.5rem">
                            <Skeleton.Input className="home__price-ticker" active={true} />
                            <Skeleton.Input className="home__price-ticker" active={true} />
                            <Skeleton.Input className="home__price-ticker" active={true} />
                        </Flex>
                    </Col>
                    <Col span={8}>
                        <Flex vertical gap="1.5rem">
                            <Skeleton.Input className="home__price-ticker" active={true} />
                            <Skeleton.Input className="home__price-ticker" active={true} />
                            <Skeleton.Input className="home__price-ticker" active={true} />
                        </Flex>
                    </Col>
                    <Col span={8}>
                        <Flex vertical gap="1.5rem">
                            <Skeleton.Input className="home__price-ticker" active={true} />
                            <Skeleton.Input className="home__price-ticker" active={true} />
                            <Skeleton.Input className="home__price-ticker" active={true} />
                        </Flex>
                    </Col>
                </Row>
            </LayoutGrid>
        </ComponentContainer>
    );
};

export const SkeletonRankingsContent = () => {
    return (
        <ComponentContainer>
            <LayoutGrid spacingTop="4" spacingBottom="4" cols={1}>
                <Row gutter={16}>
                    <Col span={8}>
                        <Flex vertical gap="1.5rem">
                            <Skeleton.Input className="home__price-ticker" active={true} />
                            <Skeleton.Input className="home__price-ticker" active={true} />
                            <Skeleton.Input className="home__price-ticker" active={true} />
                        </Flex>
                    </Col>
                    <Col span={8}>
                        <Flex vertical gap="1.5rem">
                            <Skeleton.Input className="home__price-ticker" active={true} />
                            <Skeleton.Input className="home__price-ticker" active={true} />
                            <Skeleton.Input className="home__price-ticker" active={true} />
                        </Flex>
                    </Col>
                    <Col span={8}>
                        <Flex vertical gap="1.5rem">
                            <Skeleton.Input className="home__price-ticker" active={true} />
                            <Skeleton.Input className="home__price-ticker" active={true} />
                            <Skeleton.Input className="home__price-ticker" active={true} />
                        </Flex>
                    </Col>
                </Row>
            </LayoutGrid>
        </ComponentContainer>
    );
};

export const SkeletonCarouselProductsSlide = () => {
    return <Skeleton.Input className="home__product-slide" active={true} />;
};

export function SkeletonHeroPrices() {
    return (
        <Flex vertical gap="1.5rem" style={{ gridArea: "1 / span 4" }}>
            <Skeleton.Input className="home__price-ticker darkMode" active={true} />
            <Skeleton.Input className="home__price-ticker darkMode" active={true} />
            <Skeleton.Input className="home__price-ticker darkMode" active={true} />
            <Skeleton.Input className="home__price-ticker darkMode" active={true} />
        </Flex>
    );
}

export const SkeletonCarouselPanels = () => {
    return (
        <Flex className="pb-2" justify="center" align="center" style={{ height: "100%" }}>
            <Skeleton.Input className="home__panels-slider darkMode" active={true} />
        </Flex>
    );
};
